import React from 'react';
export function FooterSection() {
  return <footer className="bg-gray-900 py-10 px-4 text-center border-t border-gray-800" data-id="element-86">
      <div className="max-w-4xl mx-auto" data-id="element-87">
        <p className="font-sans text-gray-400 mb-4" data-id="element-88">
          © 2026 The Pawfect Shot MegaPack. All rights reserved.
        </p>
        <div className="font-sans text-sm text-gray-500 space-x-4" data-id="element-89">
          <a href="#" className="hover:text-white transition-colors" data-id="element-90">
            Privacy Policy
          </a>
          <span data-id="element-91">·</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-92">
            Terms and Conditions
          </a>
        </div>
      </div>
    </footer>;
}